<template>
  <v-card>
    <v-card-title>
      Geregistreerde bedrijven bij HIT
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table :headers="headers" :items="approved" :search="search">
      <template v-slot:item.activity="{ item }">
        <v-chip v-if="item.super === 'TRUE'" color="blue" dark>
          Supermarkt
        </v-chip>
        <v-chip v-if="item.slager === 'TRUE'" color="red" dark>Slager</v-chip>
        <v-chip v-if="item.bakker === 'TRUE'" color="grey" dark>Bakker</v-chip>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import approved from "@/data/approved.json";

export default {
  name: "GeregistreerdeZaken",
  data() {
    return {
      approved,
      search: "",
      headers: [
        {
          text: "Naam",
          value: "name",
          sortable: true,
          filterable: true
        },
        {
          text: "District",
          value: "district",
          sortable: true,
          filterable: true
        },
        {
          text: "Resort",
          value: "resort",
          sortable: true,
          filterable: true
        },
        {
          text: "Activity",
          value: "activity",
          sortable: true,
          filterable: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
